import { hot } from "react-hot-loader";

import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import TourRatingComponent from "./TourRating";

const TourRating = props => (
  <ApolloProvider client={apolloClient}>
    <TourRatingComponent {...props} />
  </ApolloProvider>
);

/* eslint-disable import/no-unused-modules */
export default hot(module)(TourRating);
